export const LOCATION_OVERWRITE = 0;
export const CHANGE_STATUS = 1;